import React, {useState} from "react";
import classNames from "classnames";
import styles from "./OptionalGroupAccordion.module.scss";
import _ from "lodash";

export default ({children, className, ...props}) => {
    const [openItem, setOpenItem] = useState(null);
    const items = _.isArray(children) ? children : [children];
    const onItemClick = itemId => {
        itemId === openItem ? setOpenItem(null) : setOpenItem(itemId);
    }

    return <div className={classNames(styles["container"], className)} {...props}>
        {items && items.map((child, index) => {
            if(!child){
                return
            }
            const isOpen = 'isOpen' in child.props ? child.props.isOpen : openItem === index;
            const clone = React.cloneElement(child, { id: index, onClick: () => onItemClick(index), isOpen });
            return <React.Fragment key={index}>
                {clone}
            </React.Fragment>
        })}
    </div>
}
